import React, { useState, useEffect } from "react";
import './Component-css/DownloadPopup.css';

function DownloadPopup({ onClose }) {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
    };
    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };

  if (!supportsPWA) {
    return null;
  }

  return (
    <div className="download-popup">
      <div className="overlay" onClick={onClose} />
      <div className="popup-content">
        <div className="popup-header">
          <img src="/logo.png" alt="App Logo" />
          <h3>Download Our App</h3>
        </div>
        <div className="text-center">
          {supportsPWA ? (
            <button
              onClick={onClick}
              className="  glow-btn"
              style={{ fontWeight: 500 }}
            >
              DOWNLOAD APP
              <img className="download-img" src='/images/downloadicon.gif'/>
              
            </button>
          ) : (
            <p>PWA install not supported on this browser.</p>
          )}
        </div>
        <button className="close-btn" onClick={onClose} aria-label="Close popup">
          &times;
        </button>
      </div>
    </div>
  );
}

export default DownloadPopup;
